export type RecordKey = string | number;

type PathOrFn<T> = RecordKey | RecordKey[] | ((elem: T) => RecordKey);
export function gatherBy<T>(
  values: readonly T[],
  pathOrFn: PathOrFn<T>,
  gatherFn: (result: Record<RecordKey, T>, key: RecordKey, element: T) => void
): Record<RecordKey, T>;

export function gatherBy<T>(
  values: readonly T[],
  pathOrFn: PathOrFn<T>,
  gatherFn: (result: Record<RecordKey, T[]>, key: RecordKey, element: T) => void
): Record<RecordKey, T[]>;

export function gatherBy<T>(
  values: readonly T[],
  pathOrFn: PathOrFn<T>,
  gatherFn: any
) {
  const genKey: (elem: T) => RecordKey =
    typeof pathOrFn === "function"
      ? pathOrFn
      : (element) => {
          if (typeof pathOrFn === "string" || typeof pathOrFn === "number")
            return element[pathOrFn as keyof typeof element] as RecordKey;

          return (pathOrFn as (string | number)[]).reduce((cur, key) => {
            if (!cur || typeof cur !== "object") return undefined;
            return cur[key as keyof typeof cur];
          }, element as unknown) as RecordKey;
        };

  return values.reduce((gathering, element) => {
    const key = genKey(element);
    gatherFn(gathering, key, element);
    return gathering;
  }, {} as Record<RecordKey, T | T[]>);
}
